// extracted by mini-css-extract-plugin
export default {"formControl":"FormSelection_formControl__5V1dP","formControlLabel":"FormSelection_formControlLabel__b7T3C"};